module.exports = __webpack_public_path__ + "static/media/nft2.c1f16ac6.jpg";